import { Component, OnInit, ChangeDetectorRef, Output, EventEmitter, Input } from '@angular/core';
// import { Ng2ImgMaxService } from 'ng2-img-max';
import { NgxImageCompressService } from 'ngx-image-compress';
import { HecResponse } from '../..//shared-interfaces/hecResponse';
import { HEC_CONSTANTS } from '../../../utilities/constants';
import { CommonHelper } from '../../../core/_config/common.helper';
import { SharedService } from '../../../shared/sharedServices/shared.service';
import { LoaderService } from '../../sharedServices/loader.service';
import { encrypt } from '../../../utilities/utilityFunctions';

@Component({
  selector: 'kt-profile-picture-update',
  templateUrl: './profile-picture-update.component.html',
  styleUrls: ['./profile-picture-update.component.scss']
})
export class ProfilePictureUpdateComponent implements OnInit {
  public loader:boolean=false;
  @Input() isImageAlert:boolean=false;
  private fileExt: string = 'jpg, jpeg, png';
  @Input() alertMsgValue:string;
  @Input() alertType:string;
  private maxSize: number = 15360;
  private selectedFilePayload: any;
  private attachmentBase64: string;
  public profileAvatarImg: string;
  @Input() isImgAvailable: boolean = false;
  @Output() outputImg = new EventEmitter();
  constructor(private cdr:ChangeDetectorRef,
    // private ng2ImgMax: Ng2ImgMaxService,
    private imageCompress: NgxImageCompressService,
    private sharedService:SharedService,
    private loaderService:LoaderService) { }

  ngOnInit() {
    this.getUserPicture()
  }

  public async changeFileSelection(e: FileList) {
    let image = e[0];
    let test: File;
    const file = e[0];
    if (this.isValidFile(file)) {
      this.loader = true;
      this.loaderService.setValue(this.loader)
      this.cdr.detectChanges();
      // this.ng2ImgMax.compressImage(image, 0.575).subscribe(
      //   async result => {
      //     test = result;
      //     await this.setAttachmentsPayload(result);
      //     this.uploadAttachment();

      //   },
      //   error => {
      //     console.log('error', error);
      //     this.loader = false;
      //     this.loaderService.setValue(this.loader)
      //   }
      // );
      const reader = new FileReader();
      reader.onload = async () => {
        const imageBase64 = reader.result as string;

        // Compress image (needs full base64 URI)
        this.imageCompress.compressFile(imageBase64, -1, 50, 50)
          .then(async (compressedImage: string) => {
            // ✅ Remove the prefix after compression
            const strippedBase64 = compressedImage.replace(/^data:image\/[a-z]+;base64,/, '');

            await this.setAttachmentsPayload(strippedBase64); // now clean
            this.uploadAttachment();
          })
          .catch((error) => {
            console.log('error', error);
            this.loader = false;
            this.loaderService.setValue(this.loader)
          });
      };
      reader.readAsDataURL(file);
    }
  }

  private isValidFile(file) {
    const extensions = (this.fileExt.split(',')).map(function (x) { return x.toLocaleLowerCase().trim(); }); // array of extensions
    const ext = file.name.toLowerCase().split('.').pop() || file.name;
    const fileSizeinKB = file.size / 1024;
    if (extensions.indexOf(ext) === -1) {
      this.isImageAlert = true;
      this.alertMsgValue = 'Error in uploading ' + file.name + ' due to invalid file type.'
      this.alertType = 'warning';
      this.cdr.detectChanges();
      setTimeout(() => {
        this.isImageAlert = false;
        this.cdr.detectChanges();
      }, 3000);
      return false;
    } else if (!file.name.match(HEC_CONSTANTS.CONSTANT_VALUES.fileAllowedFormat)) {
      this.isImageAlert = true;
      this.alertType = 'warning';
      this.alertMsgValue = 'Invalid File Name'
      this.cdr.detectChanges();
      setTimeout(() => {
        this.isImageAlert = false;
        this.cdr.detectChanges();
      }, 3000);
      return false;
    }
    else if (fileSizeinKB > this.maxSize) {
      this.isImageAlert = true
      this.alertType = 'warning';
      this.alertMsgValue = file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.'
      this.cdr.detectChanges();
      setTimeout(() => {
        this.isImageAlert = false;
        this.cdr.detectChanges();
      }, 3000);
      return false;
    }
    return true;
  }

  // private async setAttachmentsPayload(file) {
  //   this.attachmentBase64 = (await this.convertFileToBase64(file)).toString();
  // }
  private async setAttachmentsPayload(base64: string) {
		this.attachmentBase64 = base64;
	}
	

  private uploadAttachment() {    
    this.selectedFilePayload = '';
    this.selectedFilePayload = this.attachmentBase64;
    
    let payload = {
      data: this.selectedFilePayload
    }
    this.sharedService.postUpdateProfilePicture(payload)
      .subscribe(
        (res:HecResponse) => {
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            this.isImageAlert=false;
            this.getUserPicture();
            this.cdr.detectChanges();
          }
          else{
            // this.ale
          }
          this.loader = false;
      this.loaderService.setValue(this.loader)
        },
        (err) => {
      this.isImageAlert = true;
      this.alertType = 'error';
      this.alertMsgValue = 'Error in uploading profile picture';
      this.loader = false;
      this.loaderService.setValue(this.loader)
      this.cdr.detectChanges();
          console.log(err)
        }
      )
  }
  private convertFileToBase64(file): any {
    return new Promise((resolve, reject) => {
      CommonHelper.convertFileToBase64(file).then((result) => {
        resolve(result);
      })
        .catch(function (error) {
          console.log(error)
          resolve(null);
        })
    })
  }

  public getUserPicture() {
    this.sharedService.getUserProfilePicture().subscribe(
      (res: HecResponse) => {
        if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          if (res.data != "") {
            this.profileAvatarImg = res.data;
            this.isImgAvailable = true;
            this.isImageAlert = false;
            this.loader = false;
            this.outputImg.emit(res.data)
            localStorage.removeItem('Avatar')
            localStorage.setItem('Avatar', encrypt(res.data))
            this.cdr.detectChanges();
          } else {
            this.profileAvatarImg = '/assets/media/users/default.jpg';
            this.cdr.detectChanges();
          }
        }
      }
    )
    }
}
